import {
  createStyles,
  Title,
  Text,
  Button,
  Center,
  Space,
  Anchor,
  Image,
  Box,
  Stack,
  BackgroundImage,
  Modal,
  UnstyledButton,
  Menu,
  Group,
  Divider,
  List,
  TextInput,
  Textarea,
  ActionIcon,
  Notification,
  Loader,
  SegmentedControl,
  Tabs,
  Grid,
} from '@mantine/core';
import { ElfsightWidget } from 'react-elfsight-widget';
import { themeColors } from '../config/themeSettings';
import { Link, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { IconArrowUpRight, IconCheck, IconX } from '@tabler/icons';

import { useForm } from 'react-hook-form';

import { useFormspark } from '@formspark/use-formspark';

import { getValue, fetchAndActivate } from 'firebase/remote-config';

import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import ComingSoonText from './components/ComingSoonText';
import AppFlag from '../components/AppFlag';
import { remoteConfig } from '../firebase';
import NewsCard from './components/NewsCard';
import ReactPlayer from 'react-player';

const FORMSPARK_FORM_ID = '5IWk8E6J';

let schema = yup.object({
  Name: yup.string().min(2).max(20).label('Name').required(),
  Email: yup.string().email().label('Email').required(),
  Message: yup.string().min(2).label('Message').required(),
});

const news = [
  {
    imageSrc: require('../assets/news/meeting-sayhelp-india.jpg'),
    category: 'INDIA NEWS',
    title:
      'Meeting Highlights Social Impact of "Say Help" Personal Safety Application',
    authorAvatarSrc:
      'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-1.png',
    authorName: 'Marter Bagra',
    date: 'December 21, 2025',
    newsId: 'social-impact-meeting',
    source: 'AP Direct',
  },
  {
    imageSrc:
      'https://static.businessworld.in/IMG_20251213_130258_20251213172204_original_image_14.webp',
    category: 'INDIA NEWS',
    title:
      "SAYHELP App reaches masses, Nirbhaya's mother flags off over 500 auto rickshaws in a rally",
    authorAvatarSrc:
      'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-1.png',
    authorName: 'BW Online Bureau',
    date: 'December 13, 2025',
    newsId: 'india-auto-rickshaw-rally',
    source: 'BW Police World',
  },
  {
    imageSrc:
      'https://static.businessworld.in/IMG_20251211_100720_20251211100901_original_image_27.webp',
    category: 'INDIA NEWS',
    title:
      "'Say Help' app set to be implemented across Delhi with it's success in just three months of arriving in India",
    authorAvatarSrc:
      'https://static.businessworld.in/UW3RSN_IMG_20210303_145041.jpg',
    authorName: 'Ujjawala Sushil Nayudu',
    date: 'December 10, 2025',
    newsId: 'bw-police-world-delhi-implementation',
    source: 'BW Police World',
  },
  {
    imageSrc:
      'https://static.toiimg.com/thumb/msid-125116262,imgsize-21232,width-400,height-225,resizemode-72/police-a-tap-away-for-women-and-elderly-just-say-help.jpg',
    category: 'INDIA NEWS',
    title: "Police a tap away for women and elderly. Just 'Say Help'",
    authorAvatarSrc:
      'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-1.png',
    authorName: 'Abhay',
    date: 'Nov 06, 2025, 02:37 IST',
    newsId: 'police-app-launch',
    source: 'Times of India',
  },
  {
    imageSrc:
      'https://media.newindianexpress.com/newindianexpress%2F2025-11-06%2Fyydapcx6%2Fdelhi-police-1.JPG?w=1200&auto=format%2Ccompress&fit=max',
    category: 'INDIA NEWS',
    title:
      "Delhi Police busts trafficking racket in Paharganj spa after alert from 'Say Help' app",
    authorAvatarSrc:
      'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-1.png',
    authorName: 'Express News Service',
    date: '06 Nov 2025, 9:45 am',
    newsId: 'trafficking-racket-bust',
    source: 'The New Indian Express',
  },
  {
    imageSrc:
      'https://www.tribuneindia.com/sortd-service/imaginary/v22-01/jpg/large/high?url=dGhldHJpYnVuZS1zb3J0ZC1wcm8tcHJvZC1zb3J0ZC9tZWRpYTZhNGNkNjMwLWJhZGItMTFmMC1iMDY0LWVkNWUyYTYzNDljNy5qcGc=',
    category: 'INDIA NEWS',
    title:
      "Delhi's Paharganj spa immoral trafficking racket busted via 'Say Help' app alert",
    authorAvatarSrc:
      'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-1.png',
    authorName: 'Tribune News Service',
    date: '12:09 PM Nov 06, 2025 IST',
    newsId: 'paharganj-spa-raid',
    source: 'Tribune India',
  },
  {
    imageSrc: '/static/media/about-photo-2.1f82417f40ffb13ef686.jpg',
    category: 'INDIA NEWS',
    title:
      'AI-enabled safety app helps bust prostitution racket in Paharganj; six women rescued',
    authorAvatarSrc:
      'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-1.png',
    authorName: 'The Hindu Bureau',
    date: 'November 07, 2025 01:36 am IST',
    newsId: 'ai-safety-app-bust',
    source: 'The Hindu',
  },
  {
    imageSrc:
      'https://akm-img-a-in.tosshub.com/indiatoday/images/story/202511/delhi-spa-operating-immoral-trafficking-065954438-16x9_0.png?VersionId=9l2bX9cX9fjp9jSUXYwVp_VPdFWjHHdX&size=690:388',
    category: 'INDIA NEWS',
    title:
      'AI-based safety app helps bust immoral trafficking racket at Delhi spa, 6 rescued',
    authorAvatarSrc:
      'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-1.png',
    authorName: 'Arvind Ojha',
    date: 'Nov 6, 2025 14:32 IST',
    newsId: 'indiatoday-trafficking-bust',
    source: 'India Today',
  },
  {
    imageSrc:
      'https://www.devdiscourse.com/remote.axd?https://devdiscourse.blob.core.windows.net/devnews/06_11_2025_20_46_14_7595066.jpg?width=920&format=webp',
    category: 'INDIA NEWS',
    title:
      "Delhi Police Busts Human Trafficking Operation in Paharganj with 'Say Help' App",
    authorAvatarSrc:
      'https://raw.githubusercontent.com/mantinedev/mantine/master/.demo/avatars/avatar-1.png',
    authorName: 'Devdiscourse News Desk',
    date: '06-11-2025 20:47 IST',
    newsId: 'devdiscourse-trafficking-bust',
    source: 'Devdiscourse',
  },
];

const socialMediaNews = [
  {
    imageSrc: require('../assets/delhi-police-woman-distress-cover.png'),
    category: 'SOCIAL MEDIA',
    title:
      'Delhi Police provides swift assistance to woman in distress through Say Help App',
    authorAvatarSrc:
      'https://pbs.twimg.com/profile_images/1931589934789668864/cxGeCvri_400x400.jpg',
    authorName: 'DCP Central Delhi',
    date: 'Dec 06, 2024',
    newsId: 'delhi-police-swift-assistance',
    source: 'X (Twitter)',
  },
];

function OperatingStatusContent() {
  const { classes } = useStyles();

  // Success Notification after sending email
  const [emailSuccess, setEmailSuccess] = useState(false);

  // Fail Notification after sending email
  const [emailError, setEmailError] = useState(false);

  // Loader Spinner when Email starts sending
  const [emailSending, setEmailSending] = useState(false);

  const [isIndia, setIsIndia] = useState(false);
  const [isSouthAfrica, setIsSouthAfrica] = useState(false);

  const [submit, submitting] = useFormspark({
    formId: FORMSPARK_FORM_ID,
  });

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = data => {
    if (!data) return;

    const { Name, Email, Message } = data;
    const submitData = { From: Name, Email: Email, Message: Message };

    setEmailSending(true);

    submit(submitData)
      .then(result => {
        setEmailSuccess(true);
        setEmailError(false);
        setEmailSending(false);
        reset();
      })
      .catch(error => {
        console.error(error);
        setEmailSuccess(false);
        setEmailError(true);
        setEmailSending(false);
      });
  };

  useEffect(() => {
    fetchAndActivate(remoteConfig)
      .then(res => {
        const isIndia = getValue(remoteConfig, 'is_india');
        const isSouthAfrica = getValue(remoteConfig, 'is_south_africa');

        setIsIndia(isIndia._value);
        setIsSouthAfrica(isSouthAfrica._value);
      })
      .catch(err => {
        console.log(err);
      });
  }, []);

  return (
    <div>
      <section className={classes.header}>
        <Title order={2} className={classes.title}>
          Say Help News
        </Title>
      </section>
      <div className={classes.container}>
        <Box className={classes.sectionCenter}>
          <Stack>
            <Group position="apart">
              <Stack className={classes.priceDescription}>
                <Group position="left">
                  <Title order={4}>
                    Say Help is currently deploying a suite of Say Help
                    capabilities, focused on specific countries, on the Google
                    and iOS Play Stores.
                  </Title>
                </Group>

                <List
                  withPadding
                  size="md"
                  style={{
                    listStylePosition: 'outside',
                  }}>
                  <List.Item py={10}>
                    Say Help is now available across 177 countries
                  </List.Item>
                </List>
              </Stack>
              {/* <Box>
                  <Text className={classes.price}>
                    <sup className={classes.priceSign}>$</sup>
                    <b>5</b>
                  </Text>
                </Box> */}
            </Group>
          </Stack>

          <Title order={2} className={classes.title}>
            Say Help Featured in Social Media
          </Title>
          <Space h="md" />

          <Space h="xl" />
          <Grid>
            {socialMediaNews.map((newsItem, index) => (
              <Grid.Col span={12} md={6} key={index}>
                <NewsCard {...newsItem} />
              </Grid.Col>
            ))}
          </Grid>

          <Space h="xl" />
          <Space h="xl" />

          <Title order={2} className={classes.title}>
            Say Help Featured in India Press
          </Title>
          <Space h="md" />

          {/* <div className={classes.playerWrapper}>
            <Center>
              <ReactPlayer
                width="100%"
                height="100%"
                url="https://player.vimeo.com/video/1134256802"
                className={classes.reactPlayer}
                loop={true}
                config={{
                  vimeo: {
                    playerOptions: {
                      controls: true,
                      playsinline: false,
                    },
                  },
                }}
              />
            </Center>
          </div> */}

          <Space h="xl" />
          <Grid>
            {news.map((newsItem, index) => (
              <Grid.Col span={12} md={6} key={index}>
                <NewsCard {...newsItem} />
              </Grid.Col>
            ))}
          </Grid>

          <Space h="xl" />
          <Space h="xl" />

          <Title order={2} className={classes.title}>
            Check Out Our Social Media for the Latest News and Updates
          </Title>

          {isIndia === 'true' && (
            <div className={classes.widget}>
              <ElfsightWidget
                widgetId="32f17d64-d273-4bd4-9ebf-8fcc5ca0ddd8"
                async
              />
            </div>
          )}

          {isSouthAfrica === 'true' && (
            <>
              <div className={classes.widget}>
                <ElfsightWidget
                  widgetId="56e84f1d-4d28-4bb1-a28b-f1b32f922be0"
                  async
                />
              </div>
              <div className={classes.widget} mt={15}>
                <ElfsightWidget
                  widgetId="ebabcaee-8850-4207-8bd7-4c7287dda08e"
                  async
                />
              </div>
            </>
          )}

          {isIndia !== 'true' && isSouthAfrica !== 'true' && (
            <div className={classes.widget}>
              <ElfsightWidget widgetId="2a7708d3-d8b1-4d8a-bef8-4df626deb0e9" />
            </div>
          )}
          <Stack mt={100}>
            <Stack align="center">
              <Title order={1} className={classes.title}>
                Contact Us
              </Title>
              <Text size="lg">Please provide information below</Text>
            </Stack>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Stack align="left" spacing={20}>
                <TextInput
                  placeholder="Name*"
                  className={classes.input}
                  variant="unstyled"
                  {...register('Name', {
                    required: true,
                    minLength: 2,
                    maxLength: 20,
                  })}
                />
                {errors.Name && (
                  <Text weight={700} color="red" pl={15}>
                    {errors.Name?.message}
                  </Text>
                )}

                <TextInput
                  placeholder="Email*"
                  className={classes.input}
                  withAsterisk
                  variant="unstyled"
                  {...register('Email')}
                />
                {errors.Email && (
                  <Text weight={700} color="red" pl={15}>
                    {errors.Email?.message}
                  </Text>
                )}

                <Textarea
                  placeholder="Message*"
                  color="#FAFAFA"
                  variant="unstyled"
                  minRows={6}
                  maxRows={8}
                  className={classes.inputArea}
                  {...register('Message')}
                />
                {errors.Message && (
                  <Text weight={700} color="red" pl={15}>
                    {errors.Message?.message}
                  </Text>
                )}
                <Stack align="center" mt={30}>
                  {emailSending && (
                    <Stack align="center">
                      <Loader />
                      <Text>Sending...</Text>
                    </Stack>
                  )}
                  {emailSuccess && (
                    <Notification
                      icon={<IconCheck size={18} />}
                      color="teal"
                      onClose={() => setEmailSuccess(false)}>
                      <Text size="md">
                        Your message has been sent successfuly
                      </Text>
                    </Notification>
                  )}
                  {emailError && (
                    <Notification
                      icon={<IconX size={18} />}
                      color="red"
                      onClose={() => setEmailError(false)}>
                      <Text size="md">Your message has not been sent</Text>
                    </Notification>
                  )}
                </Stack>
                <Center mt={30}>
                  <Button
                    // disabled={emailSending}
                    loading={emailSending}
                    type="submit"
                    color="dark"
                    radius="md"
                    size="lg"
                    uppercase
                    rightIcon={<IconArrowUpRight />}
                    styles={{
                      root: classes.redbutton,
                      rightIcon: classes.rightIcon,
                    }}>
                    Submit Inquiry
                  </Button>
                </Center>

                {/* <Center mt={60}>
                  <Button
                    leftIcon={<WhatsappLogo />}
                    color="green"
                    radius="xl"
                    size="xl"
                    styles={{
                      root: classes.greenButton,
                      leftIcon: classes.leftIcon,
                    }}
                    onClick={() => console.log('WhatsApp Message')}>
                    <Text weight={700}>Message us on WhatsApp</Text>
                  </Button>
                </Center> */}
              </Stack>
            </form>
          </Stack>
        </Box>
      </div>
    </div>
  );
}

export default OperatingStatusContent;

const useStyles = createStyles(theme => ({
  widget: {
    display: 'flex',
    justifyContent: 'center',
    alignContent: 'center',
  },

  root: {
    fontFamily: 'Poppins',
    backgroundColor: themeColors.white,
    height: '100%',
    width: '100%',
    overflowX: 'hidden',
  },

  container: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 20,
  },

  containerDark: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,

    position: 'relative',
  },

  flex: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',

    // General Gap between header buttons title and elements
    gap: 20,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    gridTemplateRows: 'auto',
    justifyContent: 'space-between',

    '@media (max-width: 425px)': {
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto',
      justifyContent: 'center',
      alignContent: 'center',
      justifyItems: 'center',
    },
    '@media (max-width: 1000px)': {
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto',
      justifyContent: 'center',
      alignContent: 'center',
      justifyItems: 'center',
      gap: 20,
    },
  },
  terms: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    // alignItems: 'center',
    justifyContent: 'center',

    '@media (min-width: 768px)': {
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: 50,
    },

    '@media (max-width: 425px)': {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 0,
    },
  },

  menuFlex: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },

  menu: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    // alignItems: 'center',
    justifyContent: 'center',
    gpa: 10,
    borderRadius: 6,
    backgroundColor: themeColors.menu,
    height: 40,

    '@media (max-width: 550px)': {
      display: 'none',
    },
  },

  menuLink: {
    color: themeColors.white,
    paddingLeft: 34,
    paddingRight: 34,

    borderRight: '1px solid #D8D8D8',

    ':last-child': {
      borderRight: 'none',
    },
  },

  menuLinkActive: {
    color: themeColors.white,
    fontWeight: 'bold',
    paddingLeft: 34,
    paddingRight: 34,

    borderRight: '1px solid #D8D8D8',

    ':last-child': {
      borderRight: 'none',
    },

    '@media (max-width: 425px)': {
      paddingLeft: 20,
      paddingRight: 20,
      fontSize: 16,
    },
  },

  badgesTop: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    // alignItems: 'center',
    justifyContent: 'center',
    gpa: 20,

    '@media (max-width: 425px)': {
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: 20,
    },

    '@media (min-width: 426px)': {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 20,
    },

    '@media (min-width: 1023px)': {
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: 20,
    },
  },

  anchor: {
    color: themeColors.anchor,
    fontSize: 14,
  },
  badges: {
    zIndex: 100,
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 20,
  },

  apppreview: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 20,
  },

  apppreviewPosition: {
    // position: 'absolute',
    // top: 0,
  },

  header: {
    textAlign: 'center',
    display: 'grid',
    gridTemplateColumns: 'minmax(min-content, 900px)',
    gridTemplateRows: 'auto',
    justifyContent: 'center',
    justifyItems: 'center',
    gap: 20,
    // gridColumn:

    // maxWidth: 1000,
  },

  title: {
    fontFamily: 'Poppins',
    // fontSize: 26,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: themeColors.anchor,
  },

  titleWhite: {
    fontFamily: 'Poppins',
    fontSize: 26,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    // maxWidth: 900,
    textAlign: 'center',
    color: themeColors.white,

    '@media (min-width: 768px) and (max-width: 1023px) ': {
      fontSize: 20,
    },
    '@media (max-width: 767px)': {
      fontSize: 27,
    },
  },
  subtitle: {
    fontFamily: 'Poppins',
    // fontSize: 13,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 2.15,
    letterSpacing: 'normal',
    textAlign: 'center',
    color: themeColors.anchor,
  },

  redTitle: {
    fontFamily: 'Poppins',
    fontSize: '0.8rem',
    fontWeight: 'bold',
    letterSpacing: 4,
    textAlign: 'center',
    color: '#ec1d23',
    textTransform: 'uppercase',
  },

  ctaTitle: {
    fontFamily: 'Poppins',
    fontSize: '0.85rem',
    fontWeight: 'bold',
    letterSpacing: 1,
    textAlign: 'center',
    // color: '#ec1d23',
    textTransform: 'uppercase',
  },

  redbutton: {
    // updated fonts
    fontSize: 14,
    fontWeight: 'bold',
    color: themeColors.white,
    backgroundColor: '#1E1E1E',
    width: 250,
  },

  rightIcon: {
    marginLeft: 0,
  },

  containerGrey: {
    backgroundColor: themeColors.backgound,
    // height: 900,
    // minHeight: 400,
  },

  darksectionMiddle: {
    paddingLeft: 20,
    paddingRight: 20,

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 30,

    '@media (max-width: 767px) ': {
      paddingBottom: 60,
    },

    '@media (min-width: 768px) and (max-width: 1023px)': {
      paddingBottom: 80,
    },
    '@media (min-width: 1024px) ': {
      paddingBottom: 80,
    },
  },

  darksection: {
    paddingLeft: 20,
    paddingRight: 20,
  },

  photosContent: {
    maxWidth: '33%',
    '@media (max-width: 768px)': {
      maxWidth: '390px',
    },
  },

  positionUp: {
    width: '100%',
    position: 'absolute',
    bottom: '-20vw',
    // top: -330,
    left: 0,
    right: 0,
    // margin: '0 auto',

    '@media (min-width: 1024px)': {
      bottom: '-210px',
    },
    // '@media (min-width: 768px) and (max-width: 1023px)': {
    //   top: '-38vw',
    // },
    // '@media (max-width: 767px)': {
    //   top: '-38vw',
    // },
    // '@media (min-width: 1024px)': {
    //   top: '-310px',
    //   // top: '-330px',
    //   // left: '20%',
    //   // right: '20%',
    // },
    // position: 'absolute',
    // top: -100,
    // '@media (min-width: 768px) and (max-width: 1023px)': {
    //   transform: 'translate(0,-33vw)',
    // },
    // '@media (max-width: 767px)': {
    //   transform: 'translate(0,-33vw)',
    // },
    // '@media (min-width: 1024px)': {
    //   transform: 'translate(0,-337px)',
    // },
  },

  appPreview: {
    maxWidth: 854,
    width: '80%',
    height: 'auto',
    margin: '0 auto',

    '@media (min-width: 768px) and (max-width: 1023px)': {
      height: 'auto',
      margin: '0 auto',
      width: '80%',
    },
    '@media (max-width: 767px) ': {
      height: 'auto',
      margin: '0 auto',
      width: '80%',
    },
  },

  space: {
    // height: 1215,
    // minHeight: 400,
    paddingBottom: '25vw',

    '@media (min-width: 1024px)': {
      paddingBottom: '150px',
    },
  },

  sectionCenter: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '90vw',
    maxWidth: 950,
  },

  photosFlex: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 20,
    flexBasis: '33.3333333333%',
    width: '100%',

    '@media (max-width: 768px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },

  contentflex: {
    // paddingTop: 30,
    display: 'grid',
    gridTemplateColumns: 'minmax(min-content, 1fr) minmax(min-content, 1fr)',
    gridTemplateRows: 'auto',

    justifyContent: 'space-evenly',

    gap: 20,

    '@media (max-width: 767px)': {
      gridTemplateColumns: '1fr',
      gridTemplateRows: 'auto',
    },
  },

  contentflexReverse: {
    paddingTop: 50,
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'center',

    gap: 20,

    '@media (max-width: 767px)': {
      flexDirection: 'column',
    },
  },

  titleRedLine: {
    // fontSize: 16,
    fontWeight: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.88,
    letterSpacing: 'normal',
    color: themeColors.text,

    borderLeft: '6px solid #EC1D23',
    paddingLeft: 20,
  },

  description: {
    // fontSize: 13,
    fontWeight: 'normal',
    lineHeight: 2.15,
    letterSpacing: 'normal',
    paddingLeft: 30,
    paddingRight: 30,
  },

  containerDarkImage: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 20,
    paddingBottom: 20,

    '@media (min-width: 1024px)': {
      // paddingTop: 100,
      // paddingBottom: 100,
    },
  },

  titleOutline: {
    fontFamily: 'Poppins',
    WebkitTextStroke: '1px #ec1c24',
    fontSize: 26,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: themeColors.text,
  },

  advantagesFlex: {
    // paddingTop: 50,

    // paddingLeft: 30,
    // paddingRight: 30,

    '@media (max-width: 768px)': {
      paddingTop: 20,
    },

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',

    gap: 20,
    '@media (min-width: 768px)': {
      flexDirection: 'row',
      alignItems: 'flex-start',
    },
  },

  descriptionWhite: {
    fontFamily: 'Poppins',
    fontSize: 18,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.67,
    letterSpacing: 'normal',

    color: themeColors.white,
    '@media (max-width: 767px)': {
      textAlign: 'center',
      fontSize: 16,
      lineHeight: 2.13,
    },
    '@media (min-width: 1023px)': {
      fontSize: 20,
    },
  },

  advantagesDescriptionFlex: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: 350,
    '@media (min-width: 768px)': {
      alignItems: 'flex-start',
    },
  },

  advFlex: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 50,
    paddingBottom: 50,
    paddingLeft: 20,
    paddingRight: 20,

    '@media (min-width: 768px)': {
      paddingLeft: 30,
      paddingRight: 30,
    },
    '@media (min-width: 1024px)': {
      paddingTop: 100,
      paddingBottom: 100,
    },
  },

  phonePreview: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 20,

    '@media (min-width: 768px)': {
      justifyContent: 'flex-end',
      alignItems: 'flex-start',
    },
  },

  phonePreviewImages: {
    maxWidth: 150,
    width: '80%',
    // height: 'auto',
    // margin: '0 auto',
  },

  phonePreviewDescriptionTablet: {
    paddingTop: 20,

    '@media (min-width: 1024px)': {
      paddingTop: 50,
      paddingBottom: 100,
      maxWidth: 450,
    },
  },

  phonePreviewDescription: {
    paddingTop: 20,

    '@media (min-width: 768px)': {
      paddingTop: 130,
      paddingBottom: 130,
      maxWidth: 350,
    },
  },

  appPreviewImages: {
    maxWidth: 550,
    width: '100%',
  },

  flexReverse: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
  },

  flexBottom: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

    // General Gap between header buttons title and elements
    gap: 20,

    paddingLeft: 50,
    paddingRight: 50,
    '@media (min-width: 768px)': {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
  },

  flexBottomLogo: {
    alignItems: 'center',
    '@media (min-width: 768px)': {
      alignItems: 'flex-start',
    },
  },

  termsBottom: {
    zIndex: 100,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // alignItems: 'center',
    justifyContent: 'space-between',

    '@media (min-width: 768px)': {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 50,
    },
  },

  termsSocial: {
    zIndex: 100,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    justifyItems: 'center',
    gap: 20,

    // '@media (min-width: 768px)': {
    //   flexDirection: 'row',
    //   justifyContent: 'center',
    //   alignItems: 'center',
    //   gap: 50,
    // },
  },

  cta: {
    fontSize: 14,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.7,
    letterSpacing: 'normal',
    textAlign: 'center',
    color: themeColors.red,

    '@media (min-width: 768px)': {
      fontSize: 20,
    },
  },

  bottomImagePosition: {
    position: 'absolute',
    bottom: 0,
    '@media (max-width: 767px)': {
      // width: 1100,
      // height: 300,
      minWidth: 1020,
      objectPosition: 'center',
      imagePosition: 'center',
    },
    '@media (min-width: 768px) and (max-width: 1023px)': {
      minWidth: 1020,

      objectPosition: 'center',
      objectGit: 'cover',
      imagePosition: 'center',
    },

    '@media (min-width: 1024px)': {
      maxWidth: 1600,
      objectPosition: 'center',
      imagePosition: 'center',
    },
  },

  containerGreyBottom: {
    backgroundColor: themeColors.backgound,
    height: 110,
    position: 'relative',
    '@media (min-width: 768px)': {
      height: 110,
    },
    overflowX: 'clip',
    // overflowY: 'initial',
  },

  containerDarkBottom: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 200,
    position: 'relative',
    '@media (min-width: 768px)': {
      paddingTop: 160,
    },
  },
  redTitleBox: {
    paddingTop: '25vw',
    '@media (min-width: 1024px)': {
      paddingTop: 250,
    },
  },

  price: {
    // fontWeight: 'bold',
    fontSize: 20,
    textAlign: 'right',
  },

  priceDescription: {
    maxWidth: 700,
  },

  priceSign: {
    fontSize: 14,
    textAlign: 'right',
    whiteSpace: 'nowrap',
  },

  input: {
    backgroundColor: '#FAFAFA',
    paddingLeft: 15,
    paddingRight: 15,
    paddingTop: 15,
    paddingBottom: 15,
    borderRadius: 10,
    border: '1px solid #F0F0F0',
    color: '#F6F6F6',
    fontSize: 14,
    minHeight: 55,
  },

  inputArea: {
    backgroundColor: '#FAFAFA',
    padding: 15,
    borderRadius: 10,
    border: '1px solid #F0F0F0',
    color: '#F6F6F6',
    height: 190,
    fontSize: 14,
  },

  greenButton: {
    fontSize: 14,
    fontWeight: 'bold',
    color: themeColors.white,
    backgroundColor: '#23B33A',
    paddingLeft: 50,
    paddingRight: 50,
    // paddingTop: 30,/
    // paddingBottom: 30,
    height: 70,
  },

  leftIcon: {
    marginLeft: 0,
  },

  reactPlayer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
  },

  playerWrapper: {
    position: 'relative',
    paddingTop: '56.25%',
  },
}));
